import React from "react";
import logo from "../assets/logo.png";

const Footer = () => {

    return (
        <footer className="bg-light p-3 text-center">
            <div>
                <img src={logo} alt="logo" width="73" height="34"/>
                <br/>
                <span className="text-muted">Discover, enjoy and track your favorite books and audiobooks.</span>

                <div>
                    <sub>Powered by&nbsp;
                        <a href="https://openlibrary.org"
                           target="_blank"
                           rel="noreferrer">openlibrary.org</a>
                    </sub>
                </div>

            </div>
        </footer>
    )
};

export default Footer;
